import React from 'react';
import moment from 'moment-timezone';
import {sortBy} from 'lodash';
import Link from './Link';
import {cx} from '../util';

const MAX_COMPANIES = 3;

export const ListAskedAt = ({
  companyFiltered, tags, className, maxAge, lastAskedOn,
}) => {
  if (!tags || !tags.length) {
    return null;
  }

  let companies = tags;
  if (companyFiltered) { // show filtered company first
    companies = sortBy(companies, (c) => (c.id === companyFiltered ? 0 : 1));
  }

  const mostRecentOccurence = moment(lastAskedOn ?? null);

  let showMostRecent = mostRecentOccurence.isValid();
  if (showMostRecent && maxAge) {
    const cutoff = moment().subtract(maxAge.amount, maxAge.unit);
    if (mostRecentOccurence.isBefore(cutoff)) {
      showMostRecent = false;
    }
  }

  const imgTag = companies[0];

  return (
    <span className={cx('text-sm font-normal text-gray-500 whitespace-nowrap inline-flex items-center', className)}>
      {imgTag?.imageUrl && (
        <img
          className="h-4 w-4 mr-1.5 object-contain flex-shrink-0 my-0"
          alt={`${imgTag.name} logo`}
          src={imgTag.imageUrl}
        />
      )}
      Asked at&nbsp;
      {companies
        .slice(0, MAX_COMPANIES)
        .map((company, i) => (
          <span className={cx({'hidden md:inline': i > 0})} key={company.id}>
            {i > 0 && i <= Math.min(companies.length - 1, MAX_COMPANIES - 1) && ', '}
            <Link
              className="hover:text-gray-600 text-gray-500 font-normal no-underline"
              href={`/questions?company=${company.id}`}
              onClick={(e) => e.stopPropagation()}
            >
              {company.name}
            </Link>
          </span>
        ))}
      &nbsp;
      {companies.length > MAX_COMPANIES && (
        <span className="hidden md:inline">
          +&nbsp;
          {`${companies.length - MAX_COMPANIES} more`}
          &nbsp;
        </span>
      )}
      {showMostRecent && (
        <span className="hidden md:inline">
          &nbsp;• &nbsp;
          <time dateTime={mostRecentOccurence.toISOString()}>
            {moment(mostRecentOccurence).fromNow()}
          </time>
        </span>
      )}
    </span>
  );
};

export const ListAskedAtInline = ({tags, className}) => {
  if (!tags || !tags.length) return null;

  const imgTag = tags.find((tag) => !!tag.imageUrl);

  if (!imgTag) return null;

  return (
    <span className={cx('text-gray-600 font-medium', className)}>
      {imgTag?.imageUrl && (
        <img
          className="inline h-4 w-4 mr-1.5 object-contain mt-0.5 md:mt-0"
          alt={`${imgTag.name} logo`}
          src={imgTag.imageUrl}
        />
      )}
      {'Asked at '}
      {tags
        .slice(0, MAX_COMPANIES)
        .map((tag, i) => (
          <span key={tag.id}>
            {i > 0 && i <= Math.min(tags.length - 1, MAX_COMPANIES - 1) && ', '}
            {tag.name}
          </span>
        ))}
      {tags.length > MAX_COMPANIES && ` + ${tags.length - MAX_COMPANIES} more`}
    </span>
  );
};

